"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  question: "What health screenings do your breeding dogs undergo?",
  answer: "Our sires and dames are rigorously screened by board-certified specialists for heart (MVD), eye (CERF), hip, and patella health. We also conduct DNA testing for Episodic Falling Syndrome and Curly Coat Dry Eye Syndrome to ensure the highest standards of genetic health."
}, {
  id: "faq-2",
  question: "How do I apply for a Mile High Cavalier puppy?",
  answer: "We invite prospective owners to complete our online application. This helps us understand your lifestyle and ensure a perfect match. Once approved, a deposit secures your place on our waitlist for upcoming litters."
}, {
  id: "faq-3",
  question: "When are puppies ready to go to their new homes?",
  answer: "Puppies are ready to transition to their forever homes at 10 to 12 weeks of age. This additional time ensures they are well-socialized, have received their initial vaccinations, and are developmentally prepared for the change."
}, {
  id: "faq-4",
  question: "Do you offer any health guarantees for your puppies?",
  answer: "Yes, every Mile High Cavalier comes with a written health guarantee where their parents were tested for life-threatening congenital defects. We stand behind our breeding program and provide lifelong support to our puppy families."
}];
export default function LogisticsFaq() {
  return <section data-section-id="74570" id="frequently-asked-questions" className="bg-background py-24 px-6 md:px-8">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-sans text-[42px] font-bold text-foreground mb-12 text-left uppercase tracking-tight">
          Adoption Process & FAQ
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-border">
              <AccordionTrigger className="text-foreground hover:text-primary text-xl md:text-2xl font-semibold hover:no-underline transition-colors py-6 text-left font-sans">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-[18px] leading-relaxed text-foreground/90 pb-8 pt-2">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}